export type OverviewDateFilterType =
  | 'last_month'
  | 'this_month'
  | 'last_week'
  | 'last_quarter'
  | 'last_3_days'
  | 'yesterday'
  | 'year_to_date'
  | 'custom';

export const formatDateLocal = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const getInitialOverviewDates = () => {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth();

  return {
    start: formatDateLocal(new Date(currentYear, currentMonth, 1)),
    end: formatDateLocal(now),
  };
};

export const resolveOverviewDateRange = (
  dateFilter: OverviewDateFilterType,
  customStart?: string,
  customEnd?: string
): { start: string; end: string } => {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth();
  const currentDate = now.getDate();
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);

  switch (dateFilter) {
    case 'last_month':
      return {
        start: formatDateLocal(new Date(currentYear, currentMonth - 1, 1)),
        end: formatDateLocal(new Date(currentYear, currentMonth, 0)),
      };
    case 'this_month':
      return {
        start: formatDateLocal(new Date(currentYear, currentMonth, 1)),
        end: formatDateLocal(yesterday),
      };
    case 'last_week':
      return {
        start: formatDateLocal(new Date(currentYear, currentMonth, currentDate - 8)),
        end: formatDateLocal(yesterday),
      };
    case 'last_quarter':
      return {
        start: formatDateLocal(new Date(currentYear, currentMonth - 3, 1)),
        end: formatDateLocal(yesterday),
      };
    case 'last_3_days':
      return {
        start: formatDateLocal(new Date(currentYear, currentMonth, currentDate - 4)),
        end: formatDateLocal(yesterday),
      };
    case 'yesterday':
      return {
        start: formatDateLocal(new Date(currentYear, currentMonth, currentDate - 2)),
        end: formatDateLocal(yesterday),
      };
    case 'year_to_date':
      return {
        start: formatDateLocal(new Date(currentYear, 0, 1)),
        end: formatDateLocal(yesterday),
      };
    case 'custom':
      if (customStart && customEnd) {
        return { start: customStart, end: customEnd };
      }
      return {
        start: formatDateLocal(new Date(currentYear, currentMonth - 1, 1)),
        end: formatDateLocal(new Date(currentYear, currentMonth, 0)),
      };
    default:
      return {
        start: customStart || formatDateLocal(new Date(currentYear, currentMonth - 1, 1)),
        end: customEnd || formatDateLocal(new Date(currentYear, currentMonth, 0)),
      };
  }
};
